// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import EventTemplatesWrapper from './EventTemplatesListWrapper';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { mapFromActivityToTemplate } from '../../../../infrastructure/utils/events';
import EventBookableForm from './EventBookableForm/EventBookableForm';

const EventBookableActivities = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  activities,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  party,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  addEventToState,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  closeModal,
}) => {
  const [selectedActivity, setSelectedActivity] = useState(null);

  return selectedActivity ? (
    <EventBookableForm
      selectedActivity={selectedActivity}
      party={party}
      addEventToState={addEventToState}
      closeModal={closeModal}
    />
  ) : (
    <EventTemplatesWrapper
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/prop-types
      templates={activities.map(mapFromActivityToTemplate)}
      onTemplateClick={activity => setSelectedActivity(activity)}
      originalData={activities}
    />
  );
};

export default React.memo(EventBookableActivities);
